import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
import { MenuItemStylingModel } from './menu-item-styling.model';
export class MenuStylingModel extends CoreStylingModel {
/**
 * StylingModel for trigger icon
 */
iconStyling: IconStylingModel;
/**
 * MenuItemStylingModel for all items
 */
menuItemStyling: MenuItemStylingModel;
/**
 * StylingModel for dropdown panel
 */
dropdownPanel: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function MenuStylingModel_tsickle_Closure_declarations() {
/**
 * StylingModel for trigger icon
 * @type {?}
 */
MenuStylingModel.prototype.iconStyling;
/**
 * MenuItemStylingModel for all items
 * @type {?}
 */
MenuStylingModel.prototype.menuItemStyling;
/**
 * StylingModel for dropdown panel
 * @type {?}
 */
MenuStylingModel.prototype.dropdownPanel;
}

